import type { CellarModel } from './cellars.types';

export enum CellarCoolingStatusType {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  ARCHIVED = 'Archived'
}

export enum ManagementType {
  NONE = 'None',
  REMY = 'Remy',
  CUSTOM = 'Custom'
}

export interface CellarCoolingModel {
  id: string;
  name: string;
  position: number;
  is24Hours: boolean | null;
  description: string;
  management: ManagementType | null;
  status: CellarCoolingStatusType;
  model: string | null;
  cellar: CellarModel | string;
}

export interface DeleteCellarCoolingParams {
  cellarCoolingId: string;
}

export interface CreateCellarCoolingParams {
  position: number;
  model: string | null;
  description: string | null;
  status: CellarCoolingStatusType;
  management: ManagementType;
  is24Hours: boolean;
  cellarId: string;
  shouldShift: boolean | null;
}

export interface UpdateCellarCoolingParams extends CreateCellarCoolingParams {
  cellarCoolingId: string | null;
}

export interface ListCoolingsResponse {
  result: CellarCoolingModel[];
  limit: number;
  offset: number;
  count: number;
}

export type CellarCoolingSortingFields = 'name' | 'model' | 'is24Hours' | 'status';
